import React from "react";
import { connect } from "react-redux";
import Table from "react-bootstrap/Table";

const AgentsAux = props => {
  const tableBody = props.agents_aux_list.map((agent, idx) => {
    return (
      <tr key={agent.id}>
        <td>{idx + 1}</td>
        <td>{agent.name}</td>
        <td>
          {agent.status} ({agent.status_time})
        </td>
        <td>{agent.logged_in_time}</td>
      </tr>
    );
  });

  return (
    <Table striped bordered hover variant="dark">
      <thead>
        <tr>
          <th>#</th>
          <th>Agent</th>
          <th>Status(Duration)</th>
          <th>Logged In(Duration)</th>
        </tr>
      </thead>
      <tbody>{tableBody}</tbody>
    </Table>
  );
};

const mapStateToProps = state => {
  return {
    agents_aux_list: state.rmqReducer.agents.agents_aux_list,
    user: state.authReducer.user,
  };
};

export default connect(mapStateToProps, {})(AgentsAux);
